<template>
  <div v-if="!tableData.loading && !tableData.error && data.length > 0" class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th v-if="expandable">&nbsp;</th>
          <th v-for="col in columns" :key="col.id" :class="{ 'text-right': col === 'actions' }">
            {{ $t(`table.${col}`) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(dt, index) in data" :key="dt.id">
          <td v-if="expandable">
            <span v-if="expandable && dt.response.length > 0" @click="openDetails(index)" style="cursor: pointer"><i class="tim-icons icon-minimal-down"></i></span>
          </td>
          <td v-for="col in columns" :key="col.id" :class="{ 'td-actions text-right': col === 'actions' }">
            <div class="actions" v-if="col === 'actions'">
              <div v-for="(action, i) in actions" :key="i">
                <button v-if="action === 'view'" class="btn btn-sm btn-icon mr-1" :class="{ 'btn-info': action === 'view' }" @click="$emit('openDetailsModal', dt.id)" id="btnView">
                  <i v-if="action === 'view'" class="tim-icons icon-single-02"></i>
                </button>

                <button v-if="action === 'patch'" class="btn btn-sm btn-icon mr-1" :class="{ 'btn-info': action === 'patch' }" @click="$emit('openDetailsModal', dt.id)" id="btnView">
                  <i v-if="action === 'patch'" class="tim-icons icon-email-85"></i>
                </button>

                <button v-if="action === 'edit'" class="btn btn-sm btn-icon mr-1" :class="{ 'btn-success': action === 'edit' }" @click="$emit('openEditModal', dt.id)">
                  <i v-if="action === 'edit'" class="tim-icons icon-settings"></i>
                </button>
                <button v-if="action === 'delete'" class="btn btn-sm btn-icon mr-1" :class="{ 'btn-danger': action === 'delete' }" @click="$emit('openDeleteModal', dt.id)">
                  <i v-if="action === 'delete'" class="tim-icons icon-simple-remove"></i>
                </button>
              </div>
            </div>
            <div v-if="col === 'active'">
              <div v-if="dt[`${col}`] === true">Ativo</div>
              <div v-else>Inativo</div>
            </div>
            <div v-else>
              <slot v-if="col === 'name' && hasDetails" v-bind:campaign="dt"> </slot>
              <div v-else>
                {{ dt[`${col}`] }}
                <div v-if="col === 'email' && expandable && showIndex === index">
                  <slot name="expandBox" :dt="dt"></slot>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <Pagination v-if="tableData.totalPages >= 1" :currentPage="tableData.currentPage" :totalPages="tableData.totalPages" @pageChanged="onPageChange"></Pagination>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination/Pagination';
export default {
  components: {
    Pagination,
  },
  props: {
    tableData: {
      type: Object,
    },
    hasDetails: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: [],
    },
    columns: {
      type: Array,
      default: [],
    },
    actions: {
      type: Array,
      default: [],
    },
    expandable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: '',
      showIndex: null,
    };
  },
  computed: {
    hasSlotData() {
      return this.$slots.default;
    },
  },
  methods: {
    openDetails(index) {
      if (index === this.showIndex) {
        this.showIndex = null;
      } else {
        this.showIndex = index;
      }
    },
    onPageChange: function (page) {
      this.$emit('pagechanged', page);
    },
  },
};
</script>
<style scoped>
.search-control {
  max-width: 240px;
}
.actions {
  display: flex;
  justify-content: flex-end;
}
</style>
